import React from 'react';
import { clsx } from 'clsx';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'neutral' | 'ghost' | 'destructive';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  isLoading,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-[#7C3AED] text-white hover:bg-[#6D28D9] shadow-sm border border-transparent',
    secondary: 'bg-white text-[#7C3AED] border border-[#7C3AED] hover:bg-purple-50',
    neutral: 'bg-white text-[#181818] border border-[#DDDBDA] hover:bg-[#F3F3F3]',
    ghost: 'bg-transparent text-[#7C3AED] hover:bg-purple-50 hover:underline',
    destructive: 'bg-[#EA001E] text-white hover:bg-[#BA0517] shadow-sm'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-9 px-4 text-sm',
    lg: 'h-11 px-6 text-base'
  };
  return <button className={clsx('inline-flex items-center justify-center rounded-[4px] font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#7C3AED] focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none', variants[variant], sizes[size], className)} disabled={disabled || isLoading} {...props} data-id="element-149">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-150" />}
      {children}
    </button>;
}